// export function trapFocus(node) {
export function trapFocus(node, additionnalNodesArr = []) {
	const previous = document.activeElement

	// function focusable() {
	function focusable() {
		const focusable = node.querySelectorAll('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
		
		if (additionnalNodesArr) return Array.from([ ...additionnalNodesArr, ...focusable ]);
		
		return Array.from(...focusable)
	}

	function handleKeydown(event) {
		if (event.key !== 'Tab') return

		const current = document.activeElement

		const elements = focusable()
		const first = elements.at(0)
		const last = elements.at(-1)

		if (event.shiftKey && current === first) {
			last.focus()
			event.preventDefault()
		}

		if (!event.shiftKey && current === last) {
			first.focus()
			event.preventDefault()
		}
	}

	const elements = focusable()
	const alreadyActiveElement = elements.filter((el) => el === document.activeElement)[0] ?? null
	if (!alreadyActiveElement) elements[0]?.focus()
	

	node.addEventListener('keydown', handleKeydown)

	return {
		destroy() {
			node.removeEventListener('keydown', handleKeydown)
			previous?.focus({preventScroll: true})
			return null
		}
	};
}
